import React, {useEffect, useState} from "react";
import HilightTable from "../../../../components/HilightTable";
import {Button, Spinner} from "react-bootstrap";
import {withNamespaces} from "react-i18next";
import NetworkDeviceContentIconHelper from "../_helpers/NetworkDeviceContentIconHelper";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";

const NetworkDeviceContentSwitcherTable  = (
    {
        t,
        list,
        getSelected,
        unSelected,
        showModal,
        hideModal,
        deleteItem,
        onRefresh
    }) => {

    const [rows, setRows] = useState([]);
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        setRows(list)
    },[list]);

    const onChangeInput = (event, data) => {
        console.log('ON CHANGE')
        const { switcherContentParams } = data;
        switcherContentParams[event.target.name] = event.target.value;

        const changeRow = rows.find((x) => x.id === data.id);
        changeRow.switcherContentParams = switcherContentParams;


        setRows(rows);
    }
    const onChangeCheckbox = (event, data) => {
        console.log('ON CHECKBOX')
        const { switcherContentParams } = data;
        console.log(event.target.name);
        console.log(switcherContentParams);
    }

    const openModalRemove = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${model.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: () => {
                deleteItem(model)
                hideModal();
            },
            closeModal: hideModal,
        }, 'confirm')
    };

    const onChangeOrder = (direction, data) => {
        console.log(direction);
        console.log(data)
    }

    const columns = [
        {
            Header: '#',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            accessor: 'id'
        },
        {
            Header: 'type',
            headerClassName: "text-center wrapok",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return <NetworkDeviceContentIconHelper type={data.defaultApp?.label} />;
            }
        },
        {
            Header: 'label',
            accessor: 'label',
            Cell: (props) => {
                const data = props.row.original;
                console.log(data);
                return (
                    <div className="options-container">
                        <div className="options-name">
                            <b>{ data.label }</b> &nbsp; <small>ver. { data.version }</small>
                        </div>
                        <div className="options">
                            <hr/>
                            <div className="options-actions">
                                <div className="form-group">
                                    <label>{t('id-or-name')}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={"key"}
                                        onChange={(e) => onChangeInput(e, data)}
                                        value={data.switcherContentParams.key}
                                    />
                                </div>
                            </div>
                            <div className="options-actions">
                                <div className="form-group">
                                    <label>{t('reset-on-switch')}</label> &nbsp;
                                    <input
                                        className="form-check"
                                        type="checkbox"
                                        checked={data.switcherContentParams.resetOnSwitch}
                                        name={"resetOnSwitch"}
                                        onChange={(e) => onChangeCheckbox(e, data)}
                                    />
                                </div>
                            </div>
                            <div className="options-actions">
                                <div className="form-group">
                                    <label>{t('kill-after-switch')}</label> &nbsp;
                                    <input
                                        className="form-check"
                                        type="checkbox"
                                        checked={data.switcherContentParams.killAfterSwitch}
                                        name={"killAfterSwitch"}
                                        onChange={(e) => onChangeCheckbox(e, data)}
                                    />
                                </div>
                            </div>
                            <div className="options-actions">
                                <div className="form-group">
                                    <label>{t('on-startup')}</label> &nbsp;
                                    <input
                                        className="form-check"
                                        type="checkbox"
                                        checked={data.switcherContentParams.onStartup}
                                        name={"onStartup"}
                                        onChange={(e) => onChangeCheckbox(e, data)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const row = props.row.original;
                return (
                    <div>
                        <Button className="mx-1" variant={"danger"}  onClick={() => openModalRemove(row)} >
                            <i className="fas fa-trash" />
                        </Button>
                    </div>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h5>{t('no-item-launcher-items')}</h5>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={rows}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )

    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    }
})
export default withNamespaces()(connect(null, mapDispatchToProps)(NetworkDeviceContentSwitcherTable));
